import { useEffect, useState } from 'react';
import { useMe } from './me';
import { loadReferral, referralToSpend } from './referral-capture';

/**
 * The invite this browser is holding, for the get-the-app controls to pass on — or null.
 *
 * Every route out of the web app and onto a phone has to carry it, because the credit is only recorded
 * once the invited person has a verified phone, and someone who leaves for the app finishes onboarding
 * there, where a referrer held in this browser can no longer be reached. A control that hands them the
 * plain install link drops the referral at exactly the moment the product sends them away.
 *
 * It is the INVITER's id, never the caller's own — passing on one's own invite is a self-referral, which
 * the service rejects. `referralToSpend` applies the same expiry and account rules as actually spending
 * it, so a link cannot outlive or cross accounts with the invite it came from. Nothing is cleared here: a
 * click does not consume the credit, the install does, and the caller may still verify a phone in this
 * browser instead. Both routes can fire, because the ledger allows one credit per phone ever.
 *
 * Resolved in an effect so the server and the first client render agree, and the invite is applied after
 * mount — storage cannot be read while rendering on the server.
 */
export function useStoredInvite(): string | null {
  const me = useMe();
  const [ref, setRef] = useState<string | null>(null);

  useEffect(() => {
    setRef(referralToSpend({ stored: loadReferral(), userId: me?.userId ?? '', now: Date.now() }));
  }, [me?.userId]);

  return ref;
}
